import React from 'react';
import FreelancerInvoiceItem from '../../../Domain/FreelancerInvoiceItem';
import ColButton from '../../../Elements/ColButton';
import FaIcon from '../../../Elements/FaIcon';
import LoadingIcon from '../../../Elements/LoadingIcon';
import OverWindow from '../../../Elements/OverWindow';
import ShowEntityData from '../../../Elements/ShowEntityData';
import FreelancerInvoiceService from '../../../Services/FreelancerInvoiceService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';

class UploadInvoiceImageWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceFileItem: {
        freelancerInvoiceId: props.freelancerInvoiceId,
        selectedFile: null,
      },
      saving: false,
    };
    this.fileUploadOnChange = this.fileUploadOnChange.bind(this);
  }

  componentDidMount() {}

  fileUploadOnChange(e) {
    if (e.target.files.length > 0) {
      this.setState({
        invoiceFileItem: {
          ...this.state.invoiceFileItem,
          selectedFile: e.target.files[0],
        },
      });
    } else {
      this.setState({
        invoiceFileItem: {
          ...this.state.invoiceFileItem,
          selectedFile: null,
        },
      });
    }
  }

  onSubmit() {
    const data = new FormData();
    data.append('file', this.state.invoiceFileItem.selectedFile);
    data.append('FreelancerInvoiceId', this.state.invoiceFileItem.freelancerInvoiceId);
    this.setState({ saving: true });
    FreelancerInvoiceService.postUploadInvoiceImageFile(data)
      .then((result) => {
        this.setState({ saving: false });
        //  alert("kész")
        this.props.clickOnCancel(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: UIIW72');
        this.setState({ saving: false });
      });
  }

  renderInfo() {
    let classNameForInfo = 'p-1 m-1';
    return (
      <div className=''>
        <div className={classNameForInfo + ' h5 text-center'}>Info</div>
        <div className={classNameForInfo}>
          <ShowEntityData
            itemId={this.props.freelancerInvoiceId}
            entityName='Vendor Invoice'
            type={FreelancerInvoiceItem}
            serviceGetByIdFunction={FreelancerInvoiceService.GetFreelancerInvoiceById}
          />
        </div>
      </div>
    );
  }

  renderButtons() {
    return (
      <ButtonFooterContainer>
        <ColButton
          text='Cancel'
          onClick={this.props.clickOnCancel}
          disabled={this.state.saving}
        />
        <ColButton
          text='Upload File'
          type='submit'
          icon={'fa-solid fa-upload' + (this.state.loading ? ' fa-spin' : '')}
          disabled={!this.state.invoiceFileItem.selectedFile}
          spinning={this.state.saving}
        />
      </ButtonFooterContainer>
    );
  }

  render() {
    return (
      <OverWindow
        clickOnCancel={() => this.props.clickOnCancel(false)}
        title='Upload Invoice Image'
        closeOnClickOutside={false}
        iconName='fa-solid fa-upload'
        verticalScroll={true}
        minHeight='700px'
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.onSubmit();
          }}
        >
          <div className='m-2 p-2'>
            {this.renderInfo()}
            <div className='p-1 m-1 h5 text-center'>Select the image of the invoice and upload it. (jpg, pdf)</div>
            <div className='custom-file d-flex justify-content-center align-items-center m-1 p-1'>
              <FaIcon
                iconName='fa-solid fa-file-invoice-dollar'
                className='h3 text-primary p-1'
              />
              <input
                className='p-1'
                type='file'
                onChange={this.fileUploadOnChange}
                id='fileupload'
                accept='.jpg, .pdf'
              />
            </div>
          </div>
          <LoadingIcon loading={this.state.saving} />
          {this.renderButtons()}
        </form>
      </OverWindow>
    );
  }
}

export default UploadInvoiceImageWindow;
